export default __webpack_public_path__ + "media/onboarding/welcome_free_account_control-bf3c1602.png";